import React from 'react';
import LogoutIcon from 'assets/Icons/topbar/LogoutIcon';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'services/auth-service';
import { Grid, IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material';

export default function Logout() {
  /* The below code is using object destructuring to extract the `logout` function from the `useAuth` hook. The `useAuth` hook is a custom hook 
  that provides authentication-related functionality, such as logging out the user. By extracting the `logout` function, it can be used in the 
  `handleLogout` function to log the user out when the logout button is clicked. */
  const { logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  /* The handleLogout function navigates to the `/` Login page and logs the user out. */
  const handleLogout = () => {
    navigate('/');
    logout();
  };

  return (
    <Grid item>
      {isSmallScreen ? (
        <Tooltip title="Logout">
          <IconButton
            onClick={handleLogout}
            size="large"
            sx={{
              backgroundColor: '#FFFFFF',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px'
            }}
          >
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <SecondaryButton
          buttonLabel="Logout"
          iconLeft={<LogoutIcon />}
          onClick={handleLogout}
          variant="default"
          size="px-4 w-auto !bg-primary2"
        />
      )}
    </Grid>
  );
}
